module.exports = __webpack_public_path__ + "static/media/hk.3e421bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/hk.png
// module id = 1873
// module chunks = 0